export const documentSlice = (state) => state.document;
export const dashboardSlice = (state) => state.dashboard;
export const contractSlice = (state) => state.contract;
